'use strict';

import {convertDataVToVue} from '../apply_vue_data_directives.js';

export class PromosliderGroupDefault {
	constructor(component_key) {
		this.id = component_key;
		this.data = yalwa.v.components[component_key];
		this.$root = document.querySelector(`.js-${this.id}`);
	}
	
	async init() {}
	
	vue_setup(Vue) {
		const ythis = this;
		if (!this.$root) {
			return {};
		}
		const template = `${convertDataVToVue(this.$root)}`;
		
		return Vue.defineComponent({
			name: ythis.id,
			template,
			setup() {
				const currentIndex = Vue.ref(0);
				const slides = Vue.ref(ythis.data.slides);
				
				// Layout Measurements
				const containerWidth = Vue.ref(0);
				const slidePositions = Vue.ref([]);

				const measureSlider = () => {
					if (!ythis.$root) return;
					
					const viewport = ythis.$root.querySelector('.promoslider__component_container');
					if (viewport) {
						containerWidth.value = viewport.offsetWidth;
					}
					
					const slideElements = ythis.$root.querySelectorAll('.promoslider__slide');
					const positions = [];
					slideElements.forEach((el) => {
						positions.push({
							left: el.offsetLeft,
							width: el.offsetWidth
						});
					});
					slidePositions.value = positions;
				};
				
				// Dragging State
				const dragOffset = Vue.ref(0);
				const isDragging = Vue.ref(false);
				let startX = 0;
				let startY = 0;
				let isHorizontal = null; // gesture direction lock
				
				// --- AUTOSLIDE ---
				const autoSlideInterval = 10000; // 10 seconds
				let timer = null;
				
				const startTimer = () => {
					clearInterval(timer);
					timer = setInterval(() => {
						if (!isDragging.value) nextSlide();
					}, autoSlideInterval);
				};
				
				const stopTimer = () => {
					clearInterval(timer);
				};
				
				// --- Slide Methods ---
				const nextSlide = () => {
					if (currentIndex.value < slides.value.length - 1) {
						currentIndex.value++;
					} else {
						currentIndex.value = 0; // loop back to first slide
					}
					startTimer(); // reset timer on manual change
				};
				
				const prevSlide = () => {
					if (currentIndex.value > 0) {
						currentIndex.value--;
					} else {
						currentIndex.value = slides.value.length - 1; // loop to last slide
					}
					startTimer(); // reset timer on manual change
				};
				
				const goToSlide = (index) => {
					currentIndex.value = index;
					startTimer(); // reset timer on manual change
				};
				
				// --- Drag/Swipe Methods ---
				const handleTouchStart = (e) => {
					const touch = e.touches[0];
					
					startX = touch.clientX;
					startY = touch.clientY;
					
					isDragging.value = true;
					isHorizontal = null; // reset direction lock
					dragOffset.value = 0;
					
					stopTimer();
				};
				
				const handleTouchMove = (e) => {
					if (!isDragging.value) {
						return;
					}
					
					const touch = e.touches[0];
					const deltaX = touch.clientX - startX;
					const deltaY = touch.clientY - startY;
					
					// Decide direction once
					if (isHorizontal === null) {
						isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
					}
					
					// Only move slider if horizontal gesture
					if (isHorizontal) {
						e.preventDefault(); // stop vertical scroll
						dragOffset.value = deltaX;
					}
				};
				
				const handleTouchEnd = () => {
					if (!isDragging.value) {
						return;
					}
					
					const threshold = 40;
					
					if (isHorizontal) {
						if (dragOffset.value < -threshold) {
							nextSlide();
						}
						else if (dragOffset.value > threshold) {
							prevSlide();
						}
					}
					
					dragOffset.value = 0;
					isDragging.value = false;
					isHorizontal = null;
					
					startTimer();
				};
				
				// --- Track Style ---
				const trackStyle = Vue.computed(() => {
					let baseTranslate = 0;
					let isPercentage = false;
					
					if (slidePositions.value.length > 0 && containerWidth.value > 0) {
						const slide = slidePositions.value[currentIndex.value];
						if (slide) {
							const slideCenter = slide.left + (slide.width / 2);
							const viewportCenter = containerWidth.value / 2;
							baseTranslate = viewportCenter - slideCenter;
							
							// Removed bounding logic to allow first and last slides to center perfectly
						}
					} else {
						// Fallback before measurement
						baseTranslate = currentIndex.value * -100;
						isPercentage = true;
					}
					
					const moveOffset = isDragging.value ? dragOffset.value : 0;
					const unit = isPercentage ? '%' : 'px';
					
					return {
						transform: `translateX(calc(${baseTranslate}${unit} + ${moveOffset}px))`,
						transition: isDragging.value ? 'none' : 'transform 0.3s ease-out'
					};
				});
				
				let resizeObserver = null;
				
				// --- Lifecycle Hooks ---
				Vue.onMounted(() => {
					const viewport = ythis.$root.querySelector('.promoslider__component_container');
					if (viewport) {
						resizeObserver = new ResizeObserver(() => {
							// measureSlider is called automatically when the element is first observed, 
							// effectively replacing the setTimeout hack, and then fires on any true dimension changes.
							measureSlider();
						});
						resizeObserver.observe(viewport);
					}
					
					startTimer();
				});
				
				Vue.onUnmounted(() => {
					if (resizeObserver) {
						resizeObserver.disconnect();
					}
					stopTimer();
				});
				
				return {
					currentIndex, slides, nextSlide, prevSlide, goToSlide,
					handleTouchStart, handleTouchMove, handleTouchEnd,
					trackStyle, isDragging
				};
			}
		});
	}
}
